import * as React from 'react';
import {FontWeight, Text} from 'styled-typography';
import PropTypes from 'prop-types';

import {StyledButtonProduct} from './styles';

const Button = ({children, ...props}) => {
  return (
    <StyledButtonProduct {...props}>
      <Text level="5" fontWeight={FontWeight.Light}>
        {children}
      </Text>
    </StyledButtonProduct>
  );
};

Button.propTypes = {
  children: PropTypes.node,
};

Button.defaultProps = {
  width: '92px',
  height: '30px',
};

export default Button;
